'use strict';

var FaresOptimizerWebFareCurveDataService = function FaresOptimizerWebFareCurveDataService(restangular, faresOptimizerDataTransformerService) {
  var webFareCurveEndPoint = restangular.one('external').one('faresoptimizer').one('webfarecurve');
  function getWebFares(filter) {
    return webFareCurveEndPoint.get({
      filter: filter,
      pageLimit: -1
    });
  }
  function getWebFaresData(filter) {
    return getWebFares(filter).then(faresOptimizerDataTransformerService.transformWebFares);
  }
  return {
    getWebFaresData: getWebFaresData
  };
};
FaresOptimizerWebFareCurveDataService.$inject = ['Restangular', 'FaresOptimizerDataTransformerService'];
module.exports = FaresOptimizerWebFareCurveDataService;